import {
  MODULE_TYPE,
  transformModuleAssets
} from "seneca-common/features/module/module-types/wordfill";
import { ModuleRegistry } from "seneca-common/features/module/registry";

import { assetParameters, DEVICE_REQUIREMENTS } from "./consts";

export const registerComponentStaticInformation = (
  moduleRegistry: ModuleRegistry
) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.componentStaticInformation()
    .deviceRequirements(DEVICE_REQUIREMENTS)
    .assetParameters(assetParameters)
    .transformModuleAssets(transformModuleAssets)
    .root.register();
